import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    foo: 'fooText',
    box: null,
    myAddress: null,
    appSpace: null,
    myDid: null,
  },
  mutations: {

  },
  actions: {

  }
})
